import { RESET_SELECTION } from "~/Configurators/common/advancedTranslationUtils";
import { SubstepType } from "../../dtos";
import * as UnitCstics from "./UnitCstics";
import * as RailCstics from "../../../Rail/v2/configuration/classic/RailsCstics";
import * as CarriageCstics from "../../../Carriage/v2/configuration/CarriageCstics";
import type { ConfiguratorDefinition } from "~/Configurators/common/v2/StepDefinition";
import { URL_CONTACT_US } from "~/utils/url/staticUrls";
import { RESET_STANDARD_AND_LENGTH } from "~/Configurators/Linear/advancedTranslationsTransformer";
import { getCsticPossibleValues, getCsticsValue } from "~/Configurators/common/v2/helper";
import { userIsCustomer } from "~/utils/roles";
import { KmatType } from "../../getKmatType";

export const UnitConfiguratorDefinition: ConfiguratorDefinition = {
  description: [
    {
      condition: ({ mainKmat }) => {
        const [materialName] = getCsticsValue(mainKmat, UnitCstics.MaterialName);
        return materialName === "RUE";
      },
      value: "configurator.unit.step.series.tile.RUE.description",
    },
    {
      condition: ({ mainKmat }) => {
        const [materialName] = getCsticsValue(mainKmat, UnitCstics.MaterialName);
        return materialName === "KUSE";
      },
      value: "configurator.unit.step.series.tile.KUSE.description",
    },
    {
      condition: ({ mainKmat }) => {
        const [materialName] = getCsticsValue(mainKmat, UnitCstics.MaterialName);
        return materialName === "KUVE";
      },
      value: "configurator.unit.step.series.tile.KUVE.description",
    },
    {
      condition: ({ mainKmat }) => {
        const [materialName] = getCsticsValue(mainKmat, UnitCstics.MaterialName);
        return materialName === "KUVE..-W";
      },
      value: "configurator.unit.step.series.tile.KUVE-W.description",
    },
  ],
  mediaUrl: [
    {
      condition: ({ mainKmat }) => {
        const [railAmount, carriageAmount] = getCsticsValue(
          mainKmat,
          UnitCstics.RailAmount,
          UnitCstics.CarriageAmountRail1,
        );
        return railAmount === "1.0" && carriageAmount === "1.0";
      },
      value: "configurator.unit.step.systemLayout.tile.1.1.imageUrl",
    },
    {
      condition: ({ mainKmat }) => {
        const [railAmount, carriageAmount] = getCsticsValue(
          mainKmat,
          UnitCstics.RailAmount,
          UnitCstics.CarriageAmountRail1,
        );
        return railAmount === "1.0" && carriageAmount === "2.0";
      },
      value: "configurator.unit.step.systemLayout.tile.1.2.imageUrl",
    },
    {
      condition: ({ mainKmat }) => {
        const [railAmount, carriageAmount] = getCsticsValue(
          mainKmat,
          UnitCstics.RailAmount,
          UnitCstics.CarriageAmountRail1,
        );
        return railAmount === "1.0" && carriageAmount === "3.0";
      },
      value: "configurator.unit.step.systemLayout.tile.1.3.imageUrl",
    },
    {
      condition: ({ mainKmat }) => {
        const [railAmount, carriageAmount] = getCsticsValue(
          mainKmat,
          UnitCstics.RailAmount,
          UnitCstics.CarriageAmountRail1,
        );
        return railAmount === "2.0" && carriageAmount === "1.0";
      },
      value: "configurator.unit.step.systemLayout.tile.2.1.imageUrl",
    },
    {
      condition: ({ mainKmat }) => {
        const [railAmount, carriageAmount] = getCsticsValue(
          mainKmat,
          UnitCstics.RailAmount,
          UnitCstics.CarriageAmountRail1,
        );
        return railAmount === "2.0" && carriageAmount === "2.0";
      },
      value: "configurator.unit.step.systemLayout.tile.2.2.imageUrl",
    },
    {
      condition: ({ mainKmat }) => {
        const [railAmount, carriageAmount] = getCsticsValue(
          mainKmat,
          UnitCstics.RailAmount,
          UnitCstics.CarriageAmountRail1,
        );
        return railAmount === "2.0" && carriageAmount === "3.0";
      },
      value: "configurator.unit.step.systemLayout.tile.2.3.imageUrl",
    },
  ],
  pages: [
    {
      name: "configurator.unit.page.1.name",
      enabled: true,
      resetLabel: RESET_SELECTION,
      resetRequiresConfirmation: false,
      substeps: [
        {
          type: SubstepType.SystemLayout,
          name: "configurator.unit.step.systemLayout.name",
          description: "configurator.unit.step.systemLayout.description",
          info: "configurator.unit.step.systemLayout.info",
          tiles: [
            {
              name: "configurator.unit.step.systemLayout.tile.1.1.name",
              imageUrl: "configurator.unit.step.systemLayout.tile.1.1.imageUrl",
              cstics: [
                {
                  csticName: UnitCstics.RailAmount,
                  value: "1.0",
                },
                {
                  csticName: UnitCstics.CarriageAmountRail1,
                  value: "1.0",
                },
              ],
            },
            {
              name: "configurator.unit.step.systemLayout.tile.1.2.name",
              imageUrl: "configurator.unit.step.systemLayout.tile.1.2.imageUrl",
              cstics: [
                {
                  csticName: UnitCstics.RailAmount,
                  value: "1.0",
                },
                {
                  csticName: UnitCstics.CarriageAmountRail1,
                  value: "2.0",
                },
              ],
            },

            {
              name: "configurator.unit.step.systemLayout.tile.1.3.name",
              imageUrl: "configurator.unit.step.systemLayout.tile.1.3.imageUrl",
              cstics: [
                {
                  csticName: UnitCstics.RailAmount,
                  value: "1.0",
                },
                {
                  csticName: UnitCstics.CarriageAmountRail1,
                  value: "3.0",
                },
              ],
            },

            {
              name: "configurator.unit.step.systemLayout.tile.2.1.name",
              imageUrl: "configurator.unit.step.systemLayout.tile.2.1.imageUrl",
              cstics: [
                {
                  csticName: UnitCstics.RailAmount,
                  value: "2.0",
                },
                {
                  csticName: UnitCstics.CarriageAmountRail1,
                  value: "1.0",
                },
                {
                  csticName: UnitCstics.CarriageAmountRail2,
                  value: "1.0",
                },
              ],
            },

            {
              name: "configurator.unit.step.systemLayout.tile.2.2.name",
              imageUrl: "configurator.unit.step.systemLayout.tile.2.2.imageUrl",
              cstics: [
                {
                  csticName: UnitCstics.RailAmount,
                  value: "2.0",
                },
                {
                  csticName: UnitCstics.CarriageAmountRail1,
                  value: "2.0",
                },
                {
                  csticName: UnitCstics.CarriageAmountRail2,
                  value: "2.0",
                },
              ],
            },

            {
              name: "configurator.unit.step.systemLayout.tile.2.3.name",
              imageUrl: "configurator.unit.step.systemLayout.tile.2.3.imageUrl",
              cstics: [
                {
                  csticName: UnitCstics.RailAmount,
                  value: "2.0",
                },
                {
                  csticName: UnitCstics.CarriageAmountRail1,
                  value: "3.0",
                },
                {
                  csticName: UnitCstics.CarriageAmountRail2,
                  value: "3.0",
                },
              ],
            },
          ],
          tilesPerRow: 4,

          csticsToReset: [UnitCstics.RailAmount, UnitCstics.CarriageAmountRail1, UnitCstics.CarriageAmountRail2],

          visible: true,

          extraTexts: {
            helpTileName: "configurator.unit.step.systemLayout.helpTile.name",
            helpTileUrl: URL_CONTACT_US,
            helpTileImageUrl: "https://cdn.schaeffler-ecommerce.com/frontend/linear/linear_1_1_contact.png",
          },
        },
      ],
    },
    {
      name: "configurator.unit.page.2.name",
      enabled: true,
      resetLabel: RESET_SELECTION,
      resetRequiresConfirmation: false,
      substeps: [
        {
          type: SubstepType.Series,
          name: "configurator.unit.step.series.name",
          description: "configurator.unit.step.series.description",
          tiles: [
            {
              name: "RUE",
              description: "configurator.unit.step.series.tile.RUE.description",
              imageUrl: "configurator.unit.step.series.tile.RUE.imageUrl",
              info: "configurator.unit.step.series.tile.RUE.info",
              cstics: [
                {
                  csticName: UnitCstics.MaterialName,
                  value: "RUE",
                },
              ],
            },
            {
              name: "KUSE",
              description: "configurator.unit.step.series.tile.KUSE.description",
              imageUrl: "configurator.unit.step.series.tile.KUSE.imageUrl",
              info: "configurator.unit.step.series.tile.KUSE.info",
              cstics: [
                {
                  csticName: UnitCstics.MaterialName,
                  value: "KUSE",
                },
              ],
            },
            {
              name: "KUVE",
              description: "configurator.unit.step.series.tile.KUVE.description",
              imageUrl: "configurator.unit.step.series.tile.KUVE.imageUrl",
              info: "configurator.unit.step.series.tile.KUVE.info",
              cstics: [
                {
                  csticName: UnitCstics.MaterialName,
                  value: "KUVE",
                },
              ],
            },
            {
              name: "KUVE-W",
              description: "configurator.unit.step.series.tile.KUVE-W.description",
              imageUrl: "configurator.unit.step.series.tile.KUVE-W.imageUrl",
              info: "configurator.unit.step.series.tile.KUVE-W.info",
              cstics: [
                {
                  csticName: UnitCstics.MaterialName,
                  value: "KUVE..-W",
                },
              ],
            },
          ],
          tilesPerRow: 4,

          csticsToReset: [UnitCstics.MaterialName],

          visible: true,
        },

        {
          type: SubstepType.Size,
          name: "configurator.unit.step.size.name",
          description: "configurator.unit.step.size.description",
          tiles: [
            {
              name: "15",
              cstics: [
                {
                  csticName: UnitCstics.SizeCode,
                  value: "15",
                },
              ],
            },
            {
              name: "20",
              cstics: [
                {
                  csticName: UnitCstics.SizeCode,
                  value: "20",
                },
              ],
            },
            {
              name: "25",
              cstics: [
                {
                  csticName: UnitCstics.SizeCode,
                  value: "25",
                },
              ],
            },
            {
              name: "30",
              cstics: [
                {
                  csticName: UnitCstics.SizeCode,
                  value: "30",
                },
              ],
            },
            {
              name: "35",
              cstics: [
                {
                  csticName: UnitCstics.SizeCode,
                  value: "35",
                },
              ],
            },
            {
              name: "45",
              cstics: [
                {
                  csticName: UnitCstics.SizeCode,
                  value: "45",
                },
              ],
            },
            {
              name: "55",
              cstics: [
                {
                  csticName: UnitCstics.SizeCode,
                  value: "55",
                },
              ],
            },
            {
              name: "65",
              cstics: [
                {
                  csticName: UnitCstics.SizeCode,
                  value: "65",
                },
              ],
            },
            {
              name: "100",
              cstics: [
                {
                  csticName: UnitCstics.SizeCode,
                  value: "100",
                },
              ],
            },
          ],
          tilesPerRow: 12,

          csticsToReset: [UnitCstics.SizeCode],

          visible: true,
        },
      ],
    },
    {
      name: "configurator.unit.page.3.name",
      enabled: true,
      resetLabel: RESET_STANDARD_AND_LENGTH,
      resetRequiresConfirmation: true,
      substeps: [
        {
          type: SubstepType.SystemCoating,
          name: "configurator.unit.step.coating.name",
          description: "configurator.unit.step.coating.description",
          info: "configurator.unit.step.coating.info",
          footerInfo: [
            [
              {
                condition: ({ mainKmat }) => {
                  const [materialName] = getCsticsValue(mainKmat, UnitCstics.MaterialName);
                  return ["KUVE", "KUVE..-W"].includes(materialName);
                },
                value: "configurator.unit.step.coating.footerInfo",
              },
            ],
          ],
          tiles: [
            {
              name: "configurator.unit.cstic.coating./.name",
              cstics: [
                {
                  csticName: UnitCstics.Coating,
                  value: "/",
                },
              ],
            },
            {
              name: "configurator.unit.cstic.coating.RROC.name",
              description: "configurator.unit.cstic.coating.RROC.description",
              info: "configurator.unit.cstic.coating.RROC.info",
              cstics: [
                {
                  csticName: UnitCstics.Coating,
                  value: "RROC",
                },
              ],
            },
            {
              name: "configurator.unit.cstic.coating.KD.name",
              description: "configurator.unit.cstic.coating.KD.description",
              info: "configurator.unit.cstic.coating.KD.info",
              cstics: [
                {
                  csticName: UnitCstics.Coating,
                  value: "KD",
                },
              ],
            },
          ],
          tilesPerRow: 4,

          csticsToReset: [UnitCstics.Coating],

          visible: true,
        },

        {
          type: SubstepType.Length,
          name: "configurator.unit.step.length.name",
          info: "configurator.unit.step.length.info",
          footerInfo: ["configurator.unit.step.length.footerInfo"],

          csticsToReset: [RailCstics.GuidewayLength],

          visible: true,
        },

        {
          type: SubstepType.Preload,
          name: "configurator.unit.step.preload.name",
          description: "configurator.unit.step.preload.description",
          info: [
            {
              condition: ({ mainKmat }) => {
                const [materialName] = getCsticsValue(mainKmat, UnitCstics.MaterialName);
                return ["RUE"].includes(materialName);
              },
              value: "configurator.unit.step.preload.info.rue",
            },
            {
              condition: ({ mainKmat }) => {
                const [materialName] = getCsticsValue(mainKmat, UnitCstics.MaterialName);
                return ["KUSE"].includes(materialName);
              },
              value: "configurator.unit.step.preload.info.kuse",
            },
            {
              condition: ({ mainKmat }) => {
                const [materialName] = getCsticsValue(mainKmat, UnitCstics.MaterialName);
                return ["KUVE", "KUVE-W"].includes(materialName);
              },
              value: "configurator.unit.step.preload.info.kuve",
            },
          ],
          tiles: [
            {
              name: "V0",
              cstics: [
                {
                  csticName: UnitCstics.Preload,
                  value: "V0",
                },
              ],
            },
            {
              name: "V1",
              cstics: [
                {
                  csticName: UnitCstics.Preload,
                  value: "V1",
                },
              ],
            },
            {
              name: "V2",
              cstics: [
                {
                  csticName: UnitCstics.Preload,
                  value: "V2",
                },
              ],
            },
            {
              name: "V3",
              cstics: [
                {
                  csticName: UnitCstics.Preload,
                  value: "V3",
                },
              ],
            },
            {
              name: "V4",
              cstics: [
                {
                  csticName: UnitCstics.Preload,
                  value: "V4",
                },
              ],
            },
            {
              name: "V5",
              cstics: [
                {
                  csticName: UnitCstics.Preload,
                  value: "V5",
                },
              ],
            },
          ],
          tilesPerRow: 6,

          csticsToReset: [UnitCstics.Preload],

          visible: true,
        },
        {
          type: SubstepType.Accuracy,
          name: "configurator.unit.step.accuracy.name",
          description: "configurator.unit.step.accuracy.description",
          info: [
            {
              condition: ({ mainKmat }) => {
                const [materialName] = getCsticsValue(mainKmat, UnitCstics.MaterialName);
                return ["RUE"].includes(materialName);
              },
              value: "configurator.unit.step.accuracy.info.rue",
            },
            {
              condition: ({ mainKmat }) => {
                const [materialName] = getCsticsValue(mainKmat, UnitCstics.MaterialName);
                return ["KUSE"].includes(materialName);
              },
              value: "configurator.unit.step.accuracy.info.kuse",
            },
            {
              condition: ({ mainKmat }) => {
                const [materialName] = getCsticsValue(mainKmat, UnitCstics.MaterialName);
                return ["KUVE", "KUVE-W"].includes(materialName);
              },
              value: "configurator.unit.step.accuracy.info.kuve",
            },
          ],
          visible: true,
          csticsToReset: [UnitCstics.Accuracy],
          tiles: [
            {
              name: "G0",
              cstics: [
                {
                  csticName: UnitCstics.Accuracy,
                  value: "G0",
                },
              ],
            },
            {
              name: "G1",
              cstics: [
                {
                  csticName: UnitCstics.Accuracy,
                  value: "G1",
                },
              ],
            },
            {
              name: "G2",
              cstics: [
                {
                  csticName: UnitCstics.Accuracy,
                  value: "G2",
                },
              ],
            },
            {
              name: "G3",
              cstics: [
                {
                  csticName: UnitCstics.Accuracy,
                  value: "G3",
                },
              ],
            },
            {
              name: "G4",
              cstics: [
                {
                  csticName: UnitCstics.Accuracy,
                  value: "G4",
                },
              ],
            },
          ],
          tilesPerRow: 6,
        },

        {
          type: SubstepType.HeightSorting,
          name: "configurator.unit.step.heightSorting.name",
          description: "configurator.unit.step.heightSorting.description",
          info: [
            {
              condition: ({ mainKmat }) => {
                const [materialName] = getCsticsValue(mainKmat, UnitCstics.MaterialName);
                return ["RUE"].includes(materialName);
              },
              value: "configurator.unit.step.heightSorting.info.rue",
            },
            {
              condition: ({ mainKmat }) => {
                const [materialName] = getCsticsValue(mainKmat, UnitCstics.MaterialName);
                return ["KUSE"].includes(materialName);
              },
              value: "configurator.unit.step.heightSorting.info.kuse",
            },
            {
              condition: ({ mainKmat }) => {
                const [materialName] = getCsticsValue(mainKmat, UnitCstics.MaterialName);
                return ["KUVE", "KUVE-W"].includes(materialName);
              },
              value: "configurator.unit.step.heightSorting.info.kuve",
            },
          ],
          visible: [
            {
              condition: (context) => context.mainKmat.cstics[UnitCstics.RailAmount]?.value !== "1.0",
              value: true,
            },
            {
              condition: () => true,
              value: false,
            },
          ],
          csticsToReset: [UnitCstics.HeightSorting],
          tiles: [
            {
              name: "configurator.unit.step.heightSorting.tile.N.name",
              cstics: [
                {
                  csticName: UnitCstics.HeightSorting,
                  value: "N",
                },
              ],
            },
            {
              name: "configurator.unit.step.heightSorting.tile.J.name",
              cstics: [
                {
                  csticName: UnitCstics.HeightSorting,
                  value: "J",
                },
              ],
            },
          ],
          tilesPerRow: 6,
        },
      ],
    },
    {
      name: "configurator.unit.page.4.name",
      enabled: true,
      resetLabel: RESET_SELECTION,
      resetRequiresConfirmation: false,
      substeps: [
        {
          type: SubstepType.LocatingFace,
          name: "configurator.unit.step.locatingFace.name",
          description: "configurator.unit.step.locatingFace.description",
          info: "configurator.unit.step.locatingFace.info",
          visible: true,
          csticsToReset: [
            UnitCstics.RailLocatingFaceSegment1,
            UnitCstics.CarriageLocatingFaceSegment1,
            UnitCstics.RailLocatingFaceSegment2,
            UnitCstics.CarriageLocatingFaceSegment2,
          ],
          groupedTiles: [
            {
              name: "rail 1",
              visible: true,
              tiles: [
                {
                  name: "configurator.unit.cstic.railLocatingFace.O.name",
                  cstics: [
                    {
                      csticName: UnitCstics.RailLocatingFaceSegment1,
                      value: "O",
                    },
                  ],
                },
                {
                  name: "configurator.unit.cstic.railLocatingFace.U.name",
                  cstics: [
                    {
                      csticName: UnitCstics.RailLocatingFaceSegment1,
                      value: "U",
                    },
                  ],
                },
                {
                  name: "configurator.unit.cstic.carriageLocatingFace.O.name",
                  cstics: [
                    {
                      csticName: UnitCstics.CarriageLocatingFaceSegment1,
                      value: "O",
                    },
                  ],
                },
                {
                  name: "configurator.unit.cstic.carriageLocatingFace.U.name",
                  cstics: [
                    {
                      csticName: UnitCstics.CarriageLocatingFaceSegment1,
                      value: "U",
                    },
                  ],
                },
              ],
            },
            {
              name: "rail 2",
              visible: [
                {
                  condition: (context) => context.mainKmat.cstics[UnitCstics.RailAmount]?.value === "2.0",
                  value: true,
                },
                {
                  condition: () => true,
                  value: false,
                },
              ],
              tiles: [
                {
                  name: "configurator.unit.cstic.railLocatingFace.O.name",
                  cstics: [
                    {
                      csticName: UnitCstics.RailLocatingFaceSegment2,
                      value: "O",
                    },
                  ],
                },
                {
                  name: "configurator.unit.cstic.railLocatingFace.U.name",
                  cstics: [
                    {
                      csticName: UnitCstics.RailLocatingFaceSegment2,
                      value: "U",
                    },
                  ],
                },
                {
                  name: "configurator.unit.cstic.carriageLocatingFace.O.name",
                  cstics: [
                    {
                      csticName: UnitCstics.CarriageLocatingFaceSegment2,
                      value: "O",
                    },
                  ],
                },
                {
                  name: "configurator.unit.cstic.carriageLocatingFace.U.name",
                  cstics: [
                    {
                      csticName: UnitCstics.CarriageLocatingFaceSegment2,
                      value: "U",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      name: "configurator.unit.page.5.name",
      enabled: true,
      resetLabel: RESET_SELECTION,
      resetRequiresConfirmation: false,
      substeps: [
        {
          type: SubstepType.Lubrication,
          name: "configurator.unit.step.lubrication.name",
          description: "configurator.unit.step.lubrication.description",
          info: "configurator.unit.step.lubrication.info",
          tiles: [
            {
              name: "configurator.unit.cstic.lubrication.ungreased.name",
              description: "configurator.unit.cstic.lubrication.ungreased.description",
              cstics: [
                [
                  {
                    condition: ({ mainKmat }) => {
                      const [materialName] = getCsticsValue(mainKmat, UnitCstics.MaterialName);
                      return ["RUE", "KUSE"].includes(materialName);
                    },
                    value: {
                      csticName: UnitCstics.GreasingPerGreaseGroup,
                      value: "/",
                    },
                  },
                  {
                    condition: ({ mainKmat }) => {
                      const [materialName] = getCsticsValue(mainKmat, UnitCstics.MaterialName);
                      return ["KUVE", "KUVE..-W"].includes(materialName);
                    },
                    value: {
                      csticName: UnitCstics.GreasingPerGreaseGroup,
                      value: "UG",
                    },
                  },
                ],
                {
                  csticName: UnitCstics.GreasingLType,
                  value: "/",
                },
              ],
            },
            {
              name: "configurator.unit.cstic.lubrication.basic.name",
              description: "configurator.unit.cstic.lubrication.basic.description",
              cstics: [
                {
                  csticName: UnitCstics.GreasingPerGreaseGroup,
                  value: "/",
                },
                {
                  csticName: UnitCstics.GreasingLType,
                  value: "/",
                },
              ],
              visible: [
                {
                  condition: ({ mainKmat }) => {
                    const [materialName] = getCsticsValue(mainKmat, UnitCstics.MaterialName);
                    return ["KUVE", "KUVE..-W"].includes(materialName);
                  },
                  value: true,
                },
              ],
            },
            {
              name: "configurator.unit.cstic.lubrication.initial.name",
              cstics: [
                [
                  {
                    condition: ({ mainKmat }) => {
                      const [materialName] = getCsticsValue(mainKmat, UnitCstics.MaterialName);
                      return ["KWSE"].includes(materialName);
                    },
                    value: {
                      csticName: UnitCstics.GreasingPerGreaseGroup,
                      value: "GA18",
                    },
                  },
                  {
                    condition: ({ mainKmat }) => {
                      const [materialName] = getCsticsValue(mainKmat, UnitCstics.MaterialName);
                      return ["RUE"].includes(materialName);
                    },
                    value: {
                      csticName: UnitCstics.GreasingPerGreaseGroup,
                      value: "GA31",
                    },
                  },
                ],
                {
                  csticName: UnitCstics.GreasingLType,
                  value: "/",
                },
              ],
              visible: [
                {
                  condition: ({ mainKmat }) => {
                    const [materialName] = getCsticsValue(mainKmat, UnitCstics.MaterialName);
                    return ["RUE", "KUSE"].includes(materialName);
                  },
                  value: true,
                },
              ],
            },

            {
              name: "configurator.unit.cstic.lubrication.special.name",
              description: "configurator.unit.cstic.lubrication.special.description",
              cstics: [
                {
                  csticName: UnitCstics.GreasingPerGreaseGroup,
                  value: "SF",
                },
                {
                  csticName: UnitCstics.GreasingLType,
                  value: "",
                },
              ],
            },
          ],

          groupedTiles: [
            {
              tiles: [
                {
                  name: "configurator.unit.cstic.lubrication.L077.name",
                  cstics: [
                    {
                      csticName: UnitCstics.GreasingPerGreaseGroup,
                      value: "SF",
                    },
                    {
                      csticName: UnitCstics.GreasingLType,
                      value: "L077",
                    },
                  ],
                  visible: [
                    {
                      condition: ({ mainKmat }) => {
                        const values = getCsticPossibleValues(mainKmat, UnitCstics.GreasingLType);
                        return values.includes("L077");
                      },
                      value: true,
                    },
                  ],
                },

                {
                  name: "configurator.unit.cstic.lubrication.L271.name",
                  cstics: [
                    {
                      csticName: UnitCstics.GreasingPerGreaseGroup,
                      value: "SF",
                    },
                    {
                      csticName: UnitCstics.GreasingLType,
                      value: "L271",
                    },
                  ],
                  visible: [
                    {
                      condition: ({ mainKmat }) => {
                        const values = getCsticPossibleValues(mainKmat, UnitCstics.GreasingLType);
                        return values.includes("L271");
                      },
                      value: true,
                    },
                  ],
                },
                {
                  name: "configurator.unit.cstic.lubrication.L409.name",
                  cstics: [
                    {
                      csticName: UnitCstics.GreasingPerGreaseGroup,
                      value: "SF",
                    },
                    {
                      csticName: UnitCstics.GreasingLType,
                      value: "L409",
                    },
                  ],
                  visible: [
                    {
                      condition: ({ mainKmat }) => {
                        const values = getCsticPossibleValues(mainKmat, UnitCstics.GreasingLType);
                        return values.includes("L409");
                      },
                      value: true,
                    },
                  ],
                },
                {
                  name: "configurator.unit.cstic.lubrication.L430.name",
                  cstics: [
                    {
                      csticName: UnitCstics.GreasingPerGreaseGroup,
                      value: "SF",
                    },
                    {
                      csticName: UnitCstics.GreasingLType,
                      value: "L430",
                    },
                  ],
                  visible: [
                    {
                      condition: ({ mainKmat }) => {
                        const values = getCsticPossibleValues(mainKmat, UnitCstics.GreasingLType);
                        return values.includes("L430");
                      },
                      value: true,
                    },
                  ],
                },
                {
                  name: "configurator.unit.cstic.lubrication.L448.name",
                  cstics: [
                    {
                      csticName: UnitCstics.GreasingPerGreaseGroup,
                      value: "SF",
                    },
                    {
                      csticName: UnitCstics.GreasingLType,
                      value: "L448",
                    },
                  ],
                  visible: [
                    {
                      condition: ({ mainKmat }) => {
                        const values = getCsticPossibleValues(mainKmat, UnitCstics.GreasingLType);
                        return values.includes("L448");
                      },
                      value: true,
                    },
                  ],
                },
                {
                  name: "configurator.unit.cstic.lubrication.L460.name",
                  cstics: [
                    {
                      csticName: UnitCstics.GreasingPerGreaseGroup,
                      value: "SF",
                    },
                    {
                      csticName: UnitCstics.GreasingLType,
                      value: "L460",
                    },
                  ],
                  visible: [
                    {
                      condition: ({ mainKmat }) => {
                        const values = getCsticPossibleValues(mainKmat, UnitCstics.GreasingLType);
                        return values.includes("L460");
                      },
                      value: true,
                    },
                  ],
                },
                {
                  name: "configurator.unit.cstic.lubrication.L531.name",
                  cstics: [
                    {
                      csticName: UnitCstics.GreasingPerGreaseGroup,
                      value: "SF",
                    },
                    {
                      csticName: UnitCstics.GreasingLType,
                      value: "L531",
                    },
                  ],
                  visible: [
                    {
                      condition: ({ mainKmat }) => {
                        const values = getCsticPossibleValues(mainKmat, UnitCstics.GreasingLType);
                        return values.includes("L531");
                      },
                      value: true,
                    },
                  ],
                },
              ],
              visible: [
                {
                  condition: ({ mainKmat }) => {
                    const [greasingPerGreaseGroup] = getCsticsValue(mainKmat, UnitCstics.GreasingPerGreaseGroup);
                    return ["SF"].includes(greasingPerGreaseGroup);
                  },
                  value: true,
                },
              ],
            },
          ],

          tilesPerRow: 4,
          csticsToReset: [UnitCstics.GreasingPerGreaseGroup, UnitCstics.GreasingLType],
          visible: true,
        },
        {
          type: SubstepType.Attachment,
          name: "configurator.unit.step.mounting.name",
          tiles: [
            {
              name: "configurator.unit.cstic.mounting./.name",
              info: "configurator.unit.cstic.mounting./.info",
              imageUrl: "configurator.unit.cstic.mounting./.imageUrl",
              cstics: [
                {
                  csticName: UnitCstics.MountingHoleType,
                  value: "/",
                },
              ],
            },
            {
              name: "configurator.unit.cstic.mounting.U.name",
              info: "configurator.unit.cstic.mounting.U.info",
              imageUrl: "configurator.unit.cstic.mounting.U.imageUrl",
              cstics: [
                {
                  csticName: UnitCstics.MountingHoleType,
                  value: "U",
                },
                {
                  csticName: RailCstics.ClosingPlugs,
                  value: "/",
                },
              ],
            },
          ],
          csticsToReset: [UnitCstics.MountingHoleType],
          tilesPerRow: 4,
          visible: true,
        },
        {
          type: SubstepType.Closure,
          name: "configurator.unit.step.closure.name",
          info: "configurator.unit.step.closure.info",
          visible: [
            {
              condition: ({ mainKmat }) => {
                return mainKmat.cstics[UnitCstics.MountingHoleType]?.value !== "U";
              },
              value: true,
            },
          ],
          tilesPerRow: 6,
          csticsToReset: [RailCstics.ClosingPlugs],

          groupedTiles: [
            {
              name: "configurator.unit.step.closure.section.plugs.name",
              visible: true,
              tiles: [
                {
                  name: "configurator.unit.cstic.closure.KA-TN.name",
                  description: "configurator.unit.cstic.closure.KA-TN.description",
                  imageUrl: "configurator.unit.cstic.closure.KA-TN.imageUrl",
                  info: "configurator.unit.cstic.closure.KA-TN.info",
                  cstics: [
                    {
                      csticName: RailCstics.ClosingPlugs,
                      value: "KA..TN",
                    },
                  ],
                },
                {
                  name: "configurator.unit.cstic.closure.KA-TN/A.name",
                  description: "configurator.unit.cstic.closure.KA-TN/A.description",
                  imageUrl: "configurator.unit.cstic.closure.KA-TN/A.imageUrl",
                  info: "configurator.unit.cstic.closure.KA-TN/A.info",
                  cstics: [
                    {
                      csticName: RailCstics.ClosingPlugs,
                      value: "KA..TN/A",
                    },
                  ],
                },
                {
                  name: "configurator.unit.cstic.closure.KA-TN/B.name",
                  description: "configurator.unit.cstic.closure.KA-TN/B.description",
                  imageUrl: "configurator.unit.cstic.closure.KA-TN/B.imageUrl",
                  info: "configurator.unit.cstic.closure.KA-TN/B.info",
                  cstics: [
                    {
                      csticName: RailCstics.ClosingPlugs,
                      value: "KA..TN/B",
                    },
                  ],
                },
                {
                  name: "configurator.unit.cstic.closure.KA-M.name",
                  description: "configurator.unit.cstic.closure.KA-M.description",
                  imageUrl: "configurator.unit.cstic.closure.KA-M.imageUrl",
                  info: [
                    {
                      condition: ({ mainKmat }) => {
                        const [materialName] = getCsticsValue(mainKmat, UnitCstics.MaterialName);
                        return ["RUE"].includes(materialName);
                      },
                      value: "configurator.unit.cstic.closure.KA-M.info.rue",
                    },
                    {
                      condition: () => true,
                      value: "configurator.unit.cstic.closure.KA-M.info.other",
                    },
                  ],
                  cstics: [
                    {
                      csticName: RailCstics.ClosingPlugs,
                      value: "KA..M",
                    },
                  ],
                },
                {
                  name: "configurator.unit.cstic.closure.KA-M/A.name",
                  description: "configurator.unit.cstic.closure.KA-M/A.description",
                  imageUrl: "configurator.unit.cstic.closure.KA-M/A.imageUrl",
                  info: "configurator.unit.cstic.closure.KA-M/A.info",
                  cstics: [
                    {
                      csticName: RailCstics.ClosingPlugs,
                      value: "KA..M/A",
                    },
                  ],
                },
                {
                  name: "configurator.unit.cstic.closure.KA-M-konisch.name",
                  description: "configurator.unit.cstic.closure.KA-M-konisch.description",
                  imageUrl: "configurator.unit.cstic.closure.KA-M-konisch.imageUrl",
                  info: "configurator.unit.cstic.closure.KA-M-konisch.info",
                  cstics: [
                    {
                      csticName: RailCstics.ClosingPlugs,
                      value: "KA..M KONISCH",
                    },
                  ],
                },
                {
                  name: "configurator.unit.cstic.closure.KA-ST/B.name",
                  description: "configurator.unit.cstic.closure.KA-ST/B.description",
                  imageUrl: "configurator.unit.cstic.closure.KA-ST/B.imageUrl",
                  info: "configurator.unit.cstic.closure.KA-ST/B.info",
                  cstics: [
                    {
                      csticName: RailCstics.ClosingPlugs,
                      value: "KA..ST/B",
                    },
                  ],
                },
                {
                  name: "configurator.unit.cstic.closure.WITHOUT.name",
                  cstics: [
                    {
                      csticName: RailCstics.ClosingPlugs,
                      value: "/",
                    },
                    [
                      {
                        condition: ({ mainKmat }) => {
                          return mainKmat.cstics[UnitCstics.GuidewayDesign]?.value === "ADE";
                        },
                        value: {
                          csticName: UnitCstics.GuidewayDesign,
                          value: "/",
                        },
                      },
                    ],
                  ],
                },
              ],
            },
            {
              name: "configurator.unit.step.closure.section.cover.name",
              visible: [
                {
                  condition: ({ mainKmat }) => {
                    const val = mainKmat.cstics[UnitCstics.GuidewayDesign]?.value;
                    return val === "ADE" || val === "/";
                  },
                  value: true,
                },
              ],
              tiles: [
                {
                  name: "configurator.unit.cstic.closure.ADE.name",
                  description: "configurator.unit.cstic.closure.ADE.description",
                  info: "configurator.unit.cstic.closure.ADE.info",
                  imageUrl: "configurator.unit.cstic.closure.ADE.imageUrl",
                  cstics: [
                    {
                      csticName: UnitCstics.GuidewayDesign,
                      value: "ADE",
                    },
                    {
                      csticName: UnitCstics.MountingHoleType,
                      value: "/",
                    },
                    {
                      csticName: RailCstics.ClosingPlugs,
                      value: "/",
                    },
                  ],
                },
              ],
            },
            {
              name: "configurator.unit.step.closure.section.holes.name",
              visible: [
                {
                  condition: ({ mainKmat, subKmats }) => {
                    const railKmat = subKmats.find((kmat) => kmat.type === KmatType.GUIDEWAY)!;
                    const [guidewayDesign] = getCsticsValue(mainKmat, UnitCstics.GuidewayDesign);
                    const [closingPlugs] = getCsticsValue(railKmat, RailCstics.ClosingPlugs);
                    if (guidewayDesign === "ADE" || closingPlugs !== "/") {
                      return true;
                    }
                    return false;
                  },
                  value: false,
                },
                {
                  condition: () => true,
                  value: true,
                },
              ],
              tiles: [
                {
                  name: "configurator.unit.cstic.closure.hole.chamfered.name",
                  info: "configurator.unit.cstic.closure.hole.chamfered.info",
                  imageUrl: "configurator.unit.cstic.closure.hole.chamfered.imageUrl",

                  cstics: [
                    {
                      csticName: UnitCstics.CounterboreChamfered,
                      value: "J",
                    },
                    {
                      csticName: RailCstics.ClosingPlugs,
                      value: "/",
                    },
                    [
                      {
                        condition: ({ mainKmat }) => {
                          const [guidewayDesign] = getCsticsValue(mainKmat, UnitCstics.GuidewayDesign);
                          return guidewayDesign === "ADE";
                        },
                        value: {
                          csticName: RailCstics.GuidewayDesign,
                          value: "/",
                        },
                      },
                    ],
                  ],
                },
                {
                  name: "configurator.unit.cstic.closure.hole.counterbored.name",
                  info: "configurator.unit.cstic.closure.hole.counterbored.info",
                  imageUrl: "configurator.unit.cstic.closure.hole.counterbored.imageUrl",

                  cstics: [
                    {
                      csticName: UnitCstics.CounterboreChamfered,
                      value: "N",
                    },
                    {
                      csticName: RailCstics.ClosingPlugs,
                      value: "/",
                    },
                    [
                      {
                        condition: ({ mainKmat }) => {
                          const [guidewayDesign] = getCsticsValue(mainKmat, UnitCstics.GuidewayDesign);
                          return guidewayDesign === "ADE";
                        },
                        value: {
                          csticName: RailCstics.GuidewayDesign,
                          value: "/",
                        },
                      },
                    ],
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      name: "configurator.unit.page.6.name",
      enabled: true,
      resetLabel: RESET_STANDARD_AND_LENGTH,
      resetRequiresConfirmation: false,
      substeps: [
        {
          type: SubstepType.GuidewaySet,
          visible: true,

          name: "configurator.unit.step.guidewaySet.name",

          extraTexts: {
            upperMessage: "configurator.unit.step.guidewaySet.infoMessage.upper",
            lowerMessage: "configurator.unit.step.guidewaySet.infoMessage.lower",
            lengthName: "configurator.unit.cstic.guidewayLength.name", // TODO - Move to cstic
            lengthInfo: "configurator.unit.cstic.guidewayLength.info", // TODO - Move to cstic
            alarName: "configurator.unit.section.alar.name",
            alarInfo: "configurator.unit.section.alar.info",
            alarRecommended: "configurator.unit.section.alar.recommended",
            alarWarningMessage: "configurator.unit.section.alar.warning",
            partsSectionName: "configurator.unit.section.parts.name",
            partsSectionInfo: "configurator.unit.section.parts.info",
          },

          tiles: [
            // TODO...
          ],

          csticsToReset: [
            // TODO...
          ],
        },
      ],
    },
    {
      name: "configurator.unit.page.7.name",
      enabled: true,
      resetLabel: RESET_SELECTION,
      resetRequiresConfirmation: true,
      substeps: [
        {
          type: SubstepType.ReferenceCarriage,
          visible: true,
          name: "configurator.unit.step.referenceCarriage.name",
          description: "configurator.unit.step.referenceCarriage.description",
          info: "configurator.unit.step.referenceCarriage.info",

          tilesPerRow: 4,
          tiles: [
            {
              name: "configurator.unit.cstic.carriageType./.name",
              imageUrl: "configurator.unit.cstic.carriageType./.image",
              cstics: [
                {
                  csticName: CarriageCstics.CarriageDesign,
                  value: "/",
                },
              ],
              visible: [
                {
                  condition: ({ mainKmat }) => {
                    const [materialName, size] = getCsticsValue(mainKmat, UnitCstics.MaterialName, UnitCstics.SizeCode);
                    if (materialName === "KUVE..-W") {
                      return false;
                    } else if (materialName === "KUVE" && !["15", "20", "25", "30", "35", "45", "55"].includes(size)) {
                      return false;
                    } else if (materialName === "KUSE" && !["20", "25", "30", "35", "45"].includes(size)) {
                      return false;
                    } else if (materialName === "RUE" && !["25", "35", "45", "55", "65"].includes(size)) {
                      return false;
                    }
                    return true;
                  },
                  value: true,
                },
              ],
            },
            {
              name: "configurator.unit.cstic.carriageType.L.name",
              imageUrl: "configurator.unit.cstic.carriageType.L.image",
              cstics: [
                {
                  csticName: CarriageCstics.CarriageDesign,
                  value: "L",
                },
              ],
              visible: [
                {
                  condition: ({ mainKmat }) => {
                    const [materialName, size] = getCsticsValue(mainKmat, UnitCstics.MaterialName, UnitCstics.SizeCode);
                    if (materialName === "KUVE..-W") {
                      return false;
                    } else if (materialName === "KUVE" && !["20", "25", "30", "35", "45", "55"].includes(size)) {
                      return false;
                    } else if (materialName === "KUSE" && !["20", "25", "30", "35", "45"].includes(size)) {
                      return false;
                    } else if (materialName === "RUE" && !["25", "35", "45", "55", "65", "100"].includes(size)) {
                      return false;
                    }
                    return true;
                  },
                  value: true,
                },
              ],
            },
            {
              name: "configurator.unit.cstic.carriageType.S.name",
              imageUrl: "configurator.unit.cstic.carriageType.S.image",
              cstics: [
                {
                  csticName: CarriageCstics.CarriageDesign,
                  value: "S",
                },
              ],
              visible: [
                {
                  condition: ({ mainKmat }) => {
                    const [materialName, size] = getCsticsValue(mainKmat, UnitCstics.MaterialName, UnitCstics.SizeCode);
                    if (materialName !== "KUVE" || !["15", "20", "25", "30", "35", "45", "55"].includes(size)) {
                      return false;
                    }
                    return true;
                  },
                  value: true,
                },
              ],
            },
            {
              name: "configurator.unit.cstic.carriageType.SL.name",
              imageUrl: "configurator.unit.cstic.carriageType.SL.image",
              cstics: [
                {
                  csticName: CarriageCstics.CarriageDesign,
                  value: "SL",
                },
              ],
              visible: [
                {
                  condition: ({ mainKmat }) => {
                    const [materialName, size] = getCsticsValue(mainKmat, UnitCstics.MaterialName, UnitCstics.SizeCode);
                    if (materialName === "KUVE..-W") {
                      return false;
                    } else if (materialName === "KUVE" && !["20", "25", "30", "35", "45", "55"].includes(size)) {
                      return false;
                    } else if (materialName === "KUSE") {
                      return false;
                    } else if (materialName === "RUE" && !["65"].includes(size)) {
                      return false;
                    }
                    return true;
                  },
                  value: true,
                },
              ],
            },
            {
              name: "configurator.unit.cstic.carriageType.E.name",
              imageUrl: "configurator.unit.cstic.carriageType.E.image",
              cstics: [
                {
                  csticName: CarriageCstics.CarriageDesign,
                  value: "E",
                },
              ],
              visible: [
                {
                  condition: ({ mainKmat }) => {
                    const [materialName, size] = getCsticsValue(mainKmat, UnitCstics.MaterialName, UnitCstics.SizeCode);
                    if (materialName !== "KUVE" || !["15", "20", "25", "30", "35"].includes(size)) {
                      return false;
                    }
                    return true;
                  },
                  value: true,
                },
              ],
            },
            {
              name: "configurator.unit.cstic.carriageType.EC.name",
              imageUrl: "configurator.unit.cstic.carriageType.EC.image",
              cstics: [
                {
                  csticName: CarriageCstics.CarriageDesign,
                  value: "EC",
                },
              ],
              visible: [
                {
                  condition: ({ mainKmat }) => {
                    const [materialName, size] = getCsticsValue(mainKmat, UnitCstics.MaterialName, UnitCstics.SizeCode);
                    if (materialName !== "KUVE" || !["15", "20", "25", "30", "35", "45"].includes(size)) {
                      return false;
                    }
                    return true;
                  },
                  value: true,
                },
              ],
            },
            {
              name: "configurator.unit.cstic.carriageType.ES.name",
              imageUrl: "configurator.unit.cstic.carriageType.ES.image",
              cstics: [
                {
                  csticName: CarriageCstics.CarriageDesign,
                  value: "ES",
                },
              ],
              visible: [
                {
                  condition: ({ mainKmat }) => {
                    const [materialName, size] = getCsticsValue(mainKmat, UnitCstics.MaterialName, UnitCstics.SizeCode);
                    if (materialName !== "KUVE" || !["20", "25"].includes(size)) {
                      return false;
                    }
                    return true;
                  },
                  value: true,
                },
              ],
            },
            {
              name: "configurator.unit.cstic.carriageType.ESC.name",
              imageUrl: "configurator.unit.cstic.carriageType.ESC.image",
              cstics: [
                {
                  csticName: CarriageCstics.CarriageDesign,
                  value: "ESC",
                },
              ],
              visible: [
                {
                  condition: ({ mainKmat }) => {
                    const [materialName, size] = getCsticsValue(mainKmat, UnitCstics.MaterialName, UnitCstics.SizeCode);
                    if (materialName !== "KUVE" || !["15", "20", "25", "30", "35", "45"].includes(size)) {
                      return false;
                    }
                    return true;
                  },
                  value: true,
                },
              ],
            },
            {
              name: "configurator.unit.cstic.carriageType.H.name",
              imageUrl: "configurator.unit.cstic.carriageType.H.image",
              cstics: [
                {
                  csticName: CarriageCstics.CarriageDesign,
                  value: "H",
                },
              ],
              visible: [
                {
                  condition: ({ mainKmat }) => {
                    const [materialName, size] = getCsticsValue(mainKmat, UnitCstics.MaterialName, UnitCstics.SizeCode);
                    if (materialName === "KUVE..-W") {
                      return false;
                    } else if (materialName === "KUSE" && !["20", "25", "30"].includes(size)) {
                      return false;
                    } else if (materialName === "KUVE" && !["15", "25", "30", "35", "45"].includes(size)) {
                      return false;
                    } else if (materialName === "RUE" && !["25", "35", "45", "55", "65"].includes(size)) {
                      return false;
                    }
                    return true;
                  },
                  value: true,
                },
              ],
            },
            {
              name: "configurator.unit.cstic.carriageType.HL.name",
              imageUrl: "configurator.unit.cstic.carriageType.HL.image",
              cstics: [
                {
                  csticName: CarriageCstics.CarriageDesign,
                  value: "HL",
                },
              ],
              visible: [
                {
                  condition: ({ mainKmat }) => {
                    const [materialName, size] = getCsticsValue(mainKmat, UnitCstics.MaterialName, UnitCstics.SizeCode);
                    if (materialName === "KUVE..-W") {
                      return false;
                    } else if (materialName === "KUSE" && !["20", "25", "30"].includes(size)) {
                      return false;
                    } else if (materialName === "KUVE" && !["25", "30", "35", "45"].includes(size)) {
                      return false;
                    } else if (materialName === "RUE" && !["25", "35", "45", "55", "65"].includes(size)) {
                      return false;
                    }
                    return true;
                  },
                  value: true,
                },
              ],
            },
            {
              name: "configurator.unit.cstic.carriageType.N.name",
              imageUrl: "configurator.unit.cstic.carriageType.N.image",
              cstics: [
                {
                  csticName: CarriageCstics.CarriageDesign,
                  value: "N",
                },
              ],
              visible: [
                {
                  condition: ({ mainKmat }) => {
                    const [materialName, size] = getCsticsValue(mainKmat, UnitCstics.MaterialName, UnitCstics.SizeCode);
                    if (materialName !== "KUVE" || !["20", "25", "30", "35", "45"].includes(size)) {
                      return false;
                    }
                    return true;
                  },
                  value: true,
                },
              ],
            },
            {
              name: "configurator.unit.cstic.carriageType.NL.name",
              imageUrl: "configurator.unit.cstic.carriageType.NL.image",
              cstics: [
                {
                  csticName: CarriageCstics.CarriageDesign,
                  value: "NL",
                },
              ],
              visible: [
                {
                  condition: ({ mainKmat }) => {
                    const [materialName, size] = getCsticsValue(mainKmat, UnitCstics.MaterialName, UnitCstics.SizeCode);
                    if (materialName !== "KUVE" || !["20", "25", "30", "35", "45"].includes(size)) {
                      return false;
                    }
                    return true;
                  },
                  value: true,
                },
              ],
            },
            {
              name: "configurator.unit.cstic.carriageType.SN.name",
              imageUrl: "configurator.unit.cstic.carriageType.SN.image",
              cstics: [
                {
                  csticName: CarriageCstics.CarriageDesign,
                  value: "SN",
                },
              ],
              visible: [
                {
                  condition: ({ mainKmat }) => {
                    const [materialName, size] = getCsticsValue(mainKmat, UnitCstics.MaterialName, UnitCstics.SizeCode);
                    if (materialName !== "KUVE" || !["20", "25", "30", "35", "45"].includes(size)) {
                      return false;
                    }
                    return true;
                  },
                  value: true,
                },
              ],
            },
            {
              name: "configurator.unit.cstic.carriageType.SNL.name",
              imageUrl: "configurator.unit.cstic.carriageType.SNL.image",
              cstics: [
                {
                  csticName: CarriageCstics.CarriageDesign,
                  value: "SNL",
                },
              ],
              visible: [
                {
                  condition: ({ mainKmat }) => {
                    const [materialName, size] = getCsticsValue(mainKmat, UnitCstics.MaterialName, UnitCstics.SizeCode);
                    if (materialName !== "KUVE" || !["20", "25", "30", "35", "45"].includes(size)) {
                      return false;
                    }
                    return true;
                  },
                  value: true,
                },
              ],
            },
            {
              name: "configurator.unit.cstic.carriageType.W.name",
              imageUrl: "configurator.unit.cstic.carriageType.W.image",
              cstics: [
                {
                  csticName: CarriageCstics.CarriageDesign,
                  value: "W",
                },
              ],
              visible: [
                {
                  condition: ({ mainKmat }) => {
                    const [materialName, size] = getCsticsValue(mainKmat, UnitCstics.MaterialName, UnitCstics.SizeCode);
                    if (materialName !== "KUVE..-W" || !["15", "20", "25", "30"].includes(size)) {
                      return false;
                    }
                    return true;
                  },
                  value: true,
                },
              ],
            },
            {
              name: "configurator.unit.cstic.carriageType.WL.name",
              imageUrl: "configurator.unit.cstic.carriageType.WL.image",
              cstics: [
                {
                  csticName: CarriageCstics.CarriageDesign,
                  value: "WL",
                },
              ],
              visible: [
                {
                  condition: ({ mainKmat }) => {
                    const [materialName, size] = getCsticsValue(mainKmat, UnitCstics.MaterialName, UnitCstics.SizeCode);
                    if (materialName !== "KUVE..-W" || !["20", "25", "35"].includes(size)) {
                      return false;
                    }
                    return true;
                  },
                  value: true,
                },
              ],
            },
          ],
          csticsToReset: [CarriageCstics.CarriageDesign],
        },
        {
          type: SubstepType.SMDS,
          name: "configurator.unit.step.SMDS.name",
          info: "configurator.unit.step.SMDS.info",
          tiles: [
            {
              name: "configurator.unit.cstic.SMDS.J.name",
              cstics: [
                {
                  csticName: UnitCstics.SMDS,
                  value: "J",
                },
              ],
            },
            {
              name: "configurator.unit.cstic.SMDS.N.name",
              cstics: [
                {
                  csticName: UnitCstics.SMDS,
                  value: "N",
                },
              ],
            },
          ],
          tilesPerRow: 6,
          csticsToReset: [UnitCstics.SMDS],
          visible: [
            {
              condition: ({ mainKmat }) => {
                const [materialName, size] = getCsticsValue(mainKmat, UnitCstics.MaterialName, UnitCstics.SizeCode);
                return ["RUE"].includes(materialName) && ["35", "45", "55", "65"].includes(size);
              },
              value: true,
            },
          ],
        },
        {
          type: SubstepType.CarriageDetails,
          visible: true,
          name: "configurator.unit.step.configureCarriage.name",
          info: "configurator.unit.step.configureCarriage.info",
          footerInfo: [],

          extraTexts: {
            sealingAndLubricationSectionName:
              "configurator.unit.step.configureCarriage.section.sealingAndLubrication.name",
            sealingAndLubricationSectionInfo:
              "configurator.unit.step.configureCarriage.section.sealingAndLubrication.info",
            lubricationConnectorSectionName: "configurator.unit.cstic.lubricationConnector.name",
            lubricationConnectorSectionInfo:
              "configurator.unit.step.configureCarriage.section.lubricationConnector.info",
            lubricationConnectorManualSectionName:
              "configurator.unit.step.configureCarriage.section.lubricationConnector.manual.name",
            lubricationConnectorCentralSectionName:
              "configurator.unit.step.configureCarriage.section.lubricationConnector.central.name",
            edit: "configurator.unit.step.configureCarriage.btn.edit",
          },
        },
      ],
    },
    {
      name: "configurator.unit.page.8.name",
      enabled: true,
      resetLabel: "",
      resetRequiresConfirmation: false,
      substeps: [
        {
          type: SubstepType.SummaryPage,
          visible: true,

          info: [
            {
              condition: ({ mainKmat }) => {
                const [railAmount, locatingFaceSegment1, locatingFaceSegment2] = getCsticsValue(
                  mainKmat,
                  UnitCstics.RailAmount,
                  UnitCstics.RailLocatingFaceSegment1,
                  UnitCstics.RailLocatingFaceSegment2,
                );
                const segments =
                  +railAmount === 2 ? [locatingFaceSegment1, locatingFaceSegment2] : [locatingFaceSegment1];
                return segments.some((segment) => segment === "U") && userIsCustomer();
              },
              value: "configurator.unit.summary.info.below.business",
            },
            {
              condition: ({ mainKmat }) => {
                const [railAmount, locatingFaceSegment1, locatingFaceSegment2] = getCsticsValue(
                  mainKmat,
                  UnitCstics.RailAmount,
                  UnitCstics.RailLocatingFaceSegment1,
                  UnitCstics.RailLocatingFaceSegment2,
                );
                const segments =
                  +railAmount === 2 ? [locatingFaceSegment1, locatingFaceSegment2] : [locatingFaceSegment1];
                return segments.every((segment) => segment === "O") && userIsCustomer();
              },
              value: "configurator.unit.summary.info.above.business",
            },
            {
              condition: ({ mainKmat }) => {
                const [railAmount, locatingFaceSegment1, locatingFaceSegment2] = getCsticsValue(
                  mainKmat,
                  UnitCstics.RailAmount,
                  UnitCstics.RailLocatingFaceSegment1,
                  UnitCstics.RailLocatingFaceSegment2,
                );
                const segments =
                  +railAmount === 2 ? [locatingFaceSegment1, locatingFaceSegment2] : [locatingFaceSegment1];
                return segments.some((segment) => segment === "U");
              },
              value: "configurator.unit.summary.info.below.plus",
            },
            {
              condition: ({ mainKmat }) => {
                const [railAmount, locatingFaceSegment1, locatingFaceSegment2] = getCsticsValue(
                  mainKmat,
                  UnitCstics.RailAmount,
                  UnitCstics.RailLocatingFaceSegment1,
                  UnitCstics.RailLocatingFaceSegment2,
                );
                const segments =
                  +railAmount === 2 ? [locatingFaceSegment1, locatingFaceSegment2] : [locatingFaceSegment1];
                return segments.every((segment) => segment === "O");
              },
              value: "configurator.unit.summary.info.above.plus",
            },
          ],
        },
      ],
    },
  ],
};
